<template>
    <ContactHeader/>
    <ContactBody/>
    <ContactFooter />
  </template>
    
  <script>
    import ContactHeader from '../molecules/ContactHeader.vue'
    import ContactBody from '../molecules/ContactBody.vue'
    import ContactFooter from '../molecules/ContactFooter.vue'
  
    export default {
      name: 'ContactView',
      components: {
        ContactHeader,
        ContactBody,
        ContactFooter
      }
    }
  </script>